"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageAction = void 0;
var axios_1 = require("axios");
var commonProperties_1 = require("./lib/commonProperties");
var config_1 = require("./config");
var ENDPOINT_PAGE_ACTION = function (baseUrl) { return baseUrl + "/Page/Action"; };
exports.pageAction = function (PageNumber, Action, CatalogId, payload, baseUrl, getCookie, setCookie) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, SearchType = _a.SearchType, Integration = _a.Integration, AdId = _a.AdId, OpeningHash = _a.OpeningHash, Provider = _a.Provider, View = _a.View;
    var endpointParams = {
        PageNumber: PageNumber,
        Action: Action,
        CatalogId: CatalogId,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        PageType: PageType,
        Platform: Platform,
        Origin: Origin,
        SearchType: SearchType,
        Integration: Integration,
        AdId: AdId,
        OpeningHash: OpeningHash,
        Provider: Provider,
        View: View
    };
    return axios_1.default.post(ENDPOINT_PAGE_ACTION(baseUrl), __assign(__assign(__assign({}, endpointParams), commonProperties_1.default(getCookie, setCookie)), payload));
};
//# sourceMappingURL=page.js.map